import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const FilterModal = ({ options, selected, setSelected, onClose }) => {
  const toggleOption = (value) => {
    setSelected((prev) =>
      prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value]
    );
  };

  const allSelected = options.length > 0 && selected.length === options.length;

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelected([]); // ❌ deselect all
    } else {
      setSelected(options.map((o) => o.value)); // ✅ select all
    }
  };

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl w-[260px] shadow-lg relative">

        {/* ❌ Close Icon */}
        {/* <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-black"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button> */}

        {/* Options */}
        <div className="p-4 space-y-3">
          {options.map((opt) => (
            <label
              key={opt.value}
              className="flex items-center gap-2 text-sm cursor-pointer"
            >
              <input
                type="checkbox"
                checked={selected.includes(opt.value)}
                onChange={() => toggleOption(opt.value)}
              />
              {opt.label}
            </label>
          ))}
        </div>

        {/* Footer */}
        <div className="flex justify-between border-t px-4 py-3">
          <button
            onClick={toggleSelectAll}
            className="bg-black text-white text-xs px-4 py-1.5 rounded"
          >
            {allSelected ? "Deselect all" : "Select all"}
          </button>

          <button
            onClick={onClose}
            className="border text-xs px-4 py-1.5 rounded"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
